export function warehouseSetupPage(workspace) {
  window.analytics.page(
    'Warehouses Setup',
    {
      workspace_slug: workspace.slug,
      workspace_id: workspace.id
    },
    {
      context: {
        groupId: workspace.id
      }
    }
  )
}

export function sourceSetupPage(workspace) {
  window.analytics.page(
    'Sources Setup',
    {
      workspace_slug: workspace.slug,
      workspace_id: workspace.id
    },
    {
      context: {
        groupId: workspace.id
      }
    }
  )
}
